import styled, { css } from 'foundations-theming-specialty/utils';
import { useTranslation } from '../../../hooks/useNavConfig';
import ErrorBoundary from '../../ErrorBoundary';
import TrackedButton from '../../TrackedButton';
import { GlobalToolbarIcon } from './GlobalToolbarIcon';
import useMenuItem from '../../Menu/hooks/useMenuItem';
import { StyledListItem } from './GlobalToolbarItem';
import withTransientStyleProps from '../../../utils/withTransientStyleProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const toolbarButtonNewNotificationStyle = theme => css([".notification-parent{position:relative;.notification{width:12px;height:12px;position:absolute;top:-16px;right:-5px;border-radius:50%;background-color:", " !important;border:1.5px solid ", " !important;}}"], theme.color['do-not-use-candy-apple'], theme.color['do-not-use-obsidian']);
export const StyledButton = styled(withTransientStyleProps(TrackedButton))(({
  $additionalStyles,
  theme
}) => {
  return css(["border-style:none;border-radius:6px;background:transparent;min-width:25px;display:flex;justify-content:center;align-items:center;height:auto;padding:8px !important;&:hover{height:32px;background:", ";svg{fill:", " !important;}.icon-text-key{color:", " !important;}}.icon-text-key{padding-left:8px !important;color:", " !important;font-size:13px !important;font-weight:400 !important;}", " ", ""], theme.color['global-shell-fill-nav-item-hover'], theme.color['global-shell-icon-nav-item-hover'], theme.color['global-shell-text-nav-item-hover'], theme.color['global-shell-text-nav-item-default'], toolbarButtonNewNotificationStyle(theme), $additionalStyles);
});

/**
 * Label can be provided via raw text or translation key, but not both
 */

export function GlobalToolbarButton({
  id,
  testId,
  tabIndex,
  iconName,
  iconTitleKey,
  ariaLabel: ariaLabelProp,
  ariaLabelKey,
  ariaExpanded,
  ariaControls,
  onClick,
  onFocus,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  additionalStyles,
  additionalListItemStyles,
  itemName,
  shouldRender = true,
  showNotification,
  portalHook,
  iconTextKey,
  iconTextKeyTranslationParams,
  iconPlacement = 'left',
  notificationsButtonCountBadge
}) {
  const {
    t
  } = useTranslation();
  const ariaLabel = ariaLabelProp || (ariaLabelKey ? t(ariaLabelKey) : '');
  const {
    setRef,
    onMenuItemKeyDown
  } = useMenuItem({
    id
  });
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: `Global Toolbar - ${itemName}`,
    children: /*#__PURE__*/_jsx(StyledListItem, {
      onClick: onClick,
      onMouseDown: onMouseDown,
      "data-portal-hook": portalHook,
      role: "menuitem",
      additionalStyles: additionalListItemStyles,
      children: /*#__PURE__*/_jsxs(StyledButton, {
        id: id,
        "data-test-id": testId || id,
        "aria-expanded": ariaExpanded,
        "aria-label": ariaLabel,
        tabIndex: tabIndex,
        onKeyDown: onMenuItemKeyDown,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: setRef,
        "aria-controls": ariaExpanded ? ariaControls : undefined,
        $additionalStyles: additionalStyles,
        "data-notifications-button-count-badge": notificationsButtonCountBadge,
        children: [iconPlacement === 'left' ? /*#__PURE__*/_jsx(GlobalToolbarIcon, {
          name: iconName,
          titleKey: iconTitleKey || ariaLabelKey
        }) : null, iconTextKey ? /*#__PURE__*/_jsx("span", {
          className: "icon-text-key",
          children: t(iconTextKey, iconTextKeyTranslationParams)
        }) : null, showNotification ? /*#__PURE__*/_jsx("div", {
          className: "notification-parent",
          children: /*#__PURE__*/_jsx("div", {
            className: "notification"
          })
        }) : null, iconPlacement === 'right' ? /*#__PURE__*/_jsx(GlobalToolbarIcon, {
          name: iconName,
          titleKey: iconTitleKey || ariaLabelKey
        }) : null]
      })
    })
  });
}